import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth relies exclusively on the httpOnly `md_token` cookie (set by the
// backend on login) — `withCredentials: true` sends it on every request.
// No tokens are read from or written to localStorage.
export const api = axios.create({ baseURL: API, withCredentials: true });

export const seedOnce = async () => {
  try {
    const seeded = localStorage.getItem("md_seeded");
    if (!seeded) {
      await api.post("/seed");
      localStorage.setItem("md_seeded", "1");
    }
  } catch (e) {
    console.warn("seed skipped", e?.message);
  }
};
